import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DashboardOverview from "@/pages/DashboardOverview";
import DashboardCategory from "@/pages/DashboardCategory";
import Upload from "@/pages/Upload";
import MetricStudio from "@/pages/MetricStudio";
import UserManagement from "@/pages/UserManagement";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              <Route path="/dashboard" element={<Dashboard />}>
                <Route index element={<DashboardOverview />} />
                <Route path=":slug" element={<DashboardCategory />} />
              </Route>
              <Route path="/dashboard/branch/:branchCode" element={<Dashboard />}>
                <Route index element={<DashboardOverview />} />
              </Route>

              <Route
                path="/upload"
                element={<ProtectedRoute roles={["admin"]}><Upload /></ProtectedRoute>}
              />
              <Route
                path="/metric-studio"
                element={<ProtectedRoute roles={["admin", "analyst"]}><MetricStudio /></ProtectedRoute>}
              />
              <Route
                path="/admin/users"
                element={<ProtectedRoute roles={["admin"]}><UserManagement /></ProtectedRoute>}
              />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors closeButton position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
